<ng-container *ngIf="userType && userType.isEmployeeLogin">
  <span class="ds-color--red--dark">
    <em class="ds-icon--close-outline"></em>
    {{'leadForm.options.employeeUserLogIn1' | cxTranslate}}
    <a (click)="logUserIn()" href="javascript:void(0)">
      {{'leadForm.options.employeeUserLogIn2' | cxTranslate}}
    </a>
    {{'leadForm.options.employeeUserLogIn3' | cxTranslate}}
  </span>
</ng-container>

